<template>
  <el-form @submit.native.prevent="editNewsBanner" :inline="true">
    <div>
      <el-form-item label="选择网校">
        <el-select v-model="model.maID" placeholder="网校">
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          multiple
          v-model="model.chID"
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="二级分类">
        <el-select
          multiple
          v-model="model.coID"
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item multiple label="三级分类">
        <el-select
          v-model="choosedList"
          multiple
          placeholder="三级分类"
          @change="selectChange"
        >
          <div style="padding: 0 20px; line-height: 34px">
            <el-checkbox
              v-model="chooseAll"
              :indeterminate="indeterminate"
              @change="chooseAll_change"
            >
              全选
            </el-checkbox>
          </div>
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-card style="margin-top: 25px">
        <el-form-item label="banner标题">
          <el-input v-model="model.bannerName"></el-input>
        </el-form-item>
        <el-form-item label="banner描述">
          <el-input v-model="model.bannerDesc"></el-input>
        </el-form-item>
        <el-form-item label="跳转链接">
          <el-input v-model="model.bannerUrl"></el-input>
        </el-form-item>
        <el-form-item label="bannerID(自动生成)">
          <el-input
            :disabled="true"
            v-model="model.bannerID"
            @input="bannerID"
          ></el-input>
        </el-form-item>
        <!-- 上传bammer图 -->
        <el-upload
          class="avatar-uploader"
          :action="$http.defaults.baseURL + '/news/img/banner'"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          list-type="picture"
          :on-success="bannerUpload"
        >
          <div>
            <img v-show="showLeImg" :src="model.bannerImg" />
          </div>
          <el-button size="small" type="primary"
            >点击修改newsBanner图</el-button
          >
        </el-upload>
      </el-card>
    </div>

    <el-form-item style="margin-top: 25px">
      <el-button type="primary" native-type="submit">点击修改</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    id: {},
  },
  data() {
    return {
      showLeImg: true,
      major: [],
      bannerID: "",
      channel: [],
      course: [],
      shclass: [],
      choosedList: [],
      indeterminate: false,
      chooseAll: false,
      model: {
        bannerImg: "",
        bannerID: "",
      },
      banner: [],
      bannerCate: [],
    };
  },
  methods: {
    async editNewsBanner() {
      try {
        const res = await this.$http.put(
          "/news/banner/putedit?_id=" + `${this.id}`,
          this.model
        );
        if (res.status === 201) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
        }

        this.$router.push("/newsbanner/list");
      } catch (error) {
        console.log(error);
      }
    },
    async getNewsEditBanner() {
      try {
        const getbanner = await this.$http.get("/news/banner/getedit", {
          params: { id: this.id },
        });
        this.model.bannerImg = "/" + getbanner.data[0].bannerImg;
        this.model.bannerID = getbanner.data[0].bannerID;
        this.model.bannerName = getbanner.data[0].bannerName;
        this.model.bannerUrl = getbanner.data[0].bannerUrl;
        this.model.bannerDesc = getbanner.data[0].bannerDesc;
        /*this.model.chID = getbanner.data[0].chID;
        this.model.coID = getbanner.data[0].coID;
        this.model.shclass = getbanner.data[0].clID; */

        //console.log(this.model);
      } catch (error) {
        console.log(error);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        //console.log(getchannel);
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        //console.log(item);
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.shclass = getclass.data;
      } catch (error) {
        console.log(error);
      }
    },
    bannerUpload(res) {
      try {
        this.model.bannerImg = res.location;
        this.showLeImg = false;
      } catch (error) {
        console.log(error);
      }
    },
    handlePreview(file) {
      console.log(file);
    },

    handleRemove(uploadFile, uploadFiles) {
      console.log(uploadFile, uploadFiles);
    },
    selectChange(newSelect) {
      if (newSelect.length === this.shclass.length) {
        this.chooseAll = true;
      } else {
        this.chooseAll = false;
      }
    },
    chooseAll_change() {
      if (this.choosedList.length < this.shclass.length) {
        this.choosedList = this.shclass.map((item) => {
          return item.clID;
        });
        this.chooseAll = true;
      } else {
        this.choosedList = [];
        this.chooseAll = false;
      }
    },
  },

  created() {
    this.id && this.getNewsEditBanner(this.id);
    this.getChannel();
    this.getMajor();
  },
};
</script>

<style scoped></style>
